module.exports = __webpack_public_path__ + "static/media/ldb-logo.481b5e9d.svg";